/**
 * User data type.
 */
export enum UserDataType {
  User = 'USER',
  Pro = 'PRO',
  Admin = 'ADMIN',
}
